export default {"src":"/_next/static/media/last9.d0dcc6d7.svg","height":51,"width":123,"blurWidth":0,"blurHeight":0};